<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-md-1">
            <i style="font-size: 60px; color: grey" class="fa fa-calendar"></i>
          </div>
          <div class="col-md-11">
            <h4 class="title-card">Reporte de cancelaciones</h4>
            <small>Reporte de la programación de avanti </small>
          </div>
        </div>
      </div>
      <div class="card-content">
        <br />
        <div class="row">
          <!-- <div class="col-md-3">
            <label for="fuente">Tomar la información de:</label>
            <select
              name="fuente"
              id="fuente"
              class="form-control"
              v-model="fuente"
            >
              <option value="avanti">Avanti</option>
              <option value="gCalendar">Google Calendar</option>
            </select>
          </div> -->
          <div class="col-md-3">
            <label for="inicial">Fecha incial:</label>
            <input type="date" :max="fechaActual" v-model="fechaInicial" class="form-control" id="inicial" />
            <small class="text-danger" v-if="fechaInicial == ''">Este campo es requerido</small>
          </div>
          <div class="col-md-3">
            <label for="final">Fecha final:</label>
            <input type="date" v-model="fechaFinal" :max="fechaActual" id="final" class="form-control" />
            <small class="text-danger" v-if="fechaFinal == ''">Este campo es requerido</small>
          </div>
          <div class="col-md-3" v-if="rol == 1">
            <label for="">Sede:</label>
            <select class="form-control" v-model="sede">
              <option v-for="sede in SedesProgramacion" :key="sede.sede" :value="sede.sede"> {{ sede.sede }} </option>
            </select>
            <small class="text-danger" v-if="sede == ''">Este campo es requerido</small>
          </div>
          <div class="col-md-3">
            <label for="" style="color: white">fff</label> <br />
            <button @click="getProgramacion()" class="btn btn-success btn-fill btn-block"
              :disabled="fechaInicial == '' || fechaFinal == '' || sede == ''">
              <i class="fa fa-search"></i> Buscar programación
            </button>
          </div>
          <div class="col-md-12">
            <!-- <button class="btn btn-success btn-sm">
                  <i color="black" class="fa fa-download"></i> Exportar
                </button> -->
            <label for="" style="color: white">fff</label> <br />
            <download-excel class="btn btn-secondary btn-fill" :data="json_data" :fields="json_fields"
              worksheet="My Worksheet" :name="'Reporte-cancelaciones' + '-' + fechaInicial + '-' + '-' + fechaFinal"
              v-if="json_data != ''">
              Exportar a excel
            </download-excel>
          </div>
        </div>
        <div class="row">
          <br />
          <br />
          <br />
          <center>
            <div class="col-md-12" v-if="queriedData == ''">
              <center>
                <img src="/static/img/ICONOS/estadisticas.svg" alt="Imagen de datos vacios" width="70" />
                <p class="titulo-mensaje">Aún no hay datos para mostrar.</p>
              </center>
            </div>
          </center>
        </div>
        <!-- <button @click="getHTMLCOMPONENT()">OBTENER HTML</button> -->
        <div class="row" ref="component" v-if="queriedData != ''">
          <div class="col-md-12">
            <el-table border :data="queriedData" size="mini" class="table-responsive">
              <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth"
                :prop="column.prop" :label="column.label">
              </el-table-column></el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Vue from "vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
import JsonExcel from "vue-json-excel";
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
Vue.component("downloadExcel", JsonExcel);

export default {
  data: () => ({
    ip: "https://avanti-erp.com/",
    fuente: "avanti",
    fechaInicial: "",
    fechaFinal: "",
    queriedData: [],
    fechaActual: "",
    tableColumns: [
      {
        prop: "paciente", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Paciente", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 250, //ANCHO DE LA COLUMNA
      },
      {
        prop: "fecha", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Fecha", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 100, //ANCHO DE LA COLUMNA
      },
      {
        prop: "entidad", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Entidad", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 170, //ANCHO DE LA COLUMNA
      },
      {
        prop: "hora", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Hora", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 100, //ANCHO DE LA COLUMNA
      },
      {
        prop: "cantidad", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Cant. SSP", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        // minWidth: 150 //ANCHO DE LA COLUMNA
      },
      {
        prop: "terapeuta", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Terapeuta", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 150, //ANCHO DE LA COLUMNA
      },
      {
        prop: "especialidad", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Especialidad", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 140, //ANCHO DE LA COLUMNA
      },
      {
        prop: "ubicacion", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Ubicación", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 100, //ANCHO DE LA COLUMNA
      },
      {
        prop: "motivoCancelar", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Motivo de cancelación", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 190, //ANCHO DE LA COLUMNA
      },
      {
        prop: "usuarioCan", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Usuario Cancela", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 190, //ANCHO DE LA COLUMNA
      },
    ],
    json_fields: {
      "Nombre del paciente": "paciente",
      'Entidad': "entidad",
      "Fecha sesión": "fecha",
      'Hora': "hora",
      'Terapeuta': "terapeuta",
      'Especialidad': "especialidad",
      'Ubicación': "ubicacion",
      'Motivo de cancelación': 'motivoCancelar',
      'Usuario Cancela': 'usuarioCan'
    },
    json_data: [],
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8",
        },
      ],
    ],
    SedesProgramacion: [],
    sede: '',
    rol: ''
  }),
  methods: {
    async getProgramacion() {
      this.queriedData = [];
      if (this.fuente == "gCalendar") {
        const BASE_URL = `https://www.googleapis.com/calendar/v3/calendars/${sede}/events?key=AIzaSyCS6MXgvS2kJs7YaIkUfFGx2O1fI9BKuC0&timeMin=${this.fechaInicial}T00:00:00-05:00&timeMax=${this.fechaFinal}T00:00:00-05:00`;
        let data = await axios.get(BASE_URL);
        this.convertirProgramacion(data.data.items);
      } else {
        this.reporteAvanti();
      }
    },
    reporteAvanti: function () {
      this.$modal.show("carga");
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const BASE_URL = `${this.ip}api/reporteCancelacion/${this.fechaInicial}/${this.fechaFinal}/${this.sede}`;
      axios.get(BASE_URL, config).then((res) => {
        let datos = res.data.data;
        let dateFormated = [];
        datos.forEach((element) => {
          dateFormated.push({
            paciente: element.PacNom1 + " " + element.PacApe1,
            fecha: element.ProFec,
            hora: element.hora,
            cantidad: 1,
            terapeuta: element.terapeutaNombre,
            especialidad: element.especialidad,
            ubicacion: element.ProLug,
            entidad: element.entidad,
            motivoCancelar: element.ProMotCan,
            usuarioCan: element.ProUsuCan,
          });
          this.$modal.hide("carga");
          this.queriedData = dateFormated;
          this.json_data = dateFormated;

        });

      });

      this.$modal.hide('carga');
    },
    getHTMLCOMPONENT: function () {

      let componentHTMLTABLE = this.$refs.component.innerHTML;
      console.log('HTML TABLE', componentHTMLTABLE);


    },
    convertirProgramacion: function (data) {
      const BASE_URL = `${this.ip}api/convertirProgramacion`;
      axios
        .post(BASE_URL, {
          data: data,
        })
        .then((res) => {
          let response = res.data.data;
          let datos = [];
          response.forEach((element) => {
            let tipo = "";
            if (element.location) {
              tipo = "Virtual";
            } else {
              tipo = "Domicilio";
            }
            datos.push({
              fecha: element.start.dateTime.substring(0, 10),
              paciente:
                element.paciente[0].PacNom1 + " " + element.paciente[0].PacApe1,
              hora: this.horaFormateada(element.start.dateTime),
              cantidad: this.calcularMinutos(
                this.horaFormateada(element.start.dateTime),
                this.horaFormateada(element.end.dateTime)
              ),
              terapeuta: "N/A",
              especialidad: "N/A",
              ubicacion: tipo,
              entidad: element.entidad,
            });
          });

          this.queriedData = datos;


        });
    },
    horaFormateada(fecha) {
      var hora = new Date(fecha).getHours();
      var minutos = new Date(fecha).getMinutes();
      if (minutos == 0) {
        minutos = "00";
      }
      var horaFormateada = hora + ":" + minutos;
      return horaFormateada;
    },
    calcularMinutos(inicio, fin) {
      // Cogemos la hora inicial y final y obtenemos los minutos totales
      var horaInicial = this.devolverMinutos(inicio);
      var horaFinal = this.devolverMinutos(fin);

      if (horaInicial < horaFinal) {
        // Restamos los minutos finales con los minutos iniciales

        // console.log(
        //   "La cantidad de sesiones que se necesita es: " +
        //   (horaFinal - horaInicial / 60) +
        //   " sesion"
        // );
        let sesiones = (horaFinal - horaInicial) / 30;

        return Math.trunc(sesiones);
      } else {
        // document.getElementById("resultado").innerHTML =
        //   "La hora inicial tiene que ser inferior a la hora final";
      }
      // console.log(inicio)
    },
    devolverMinutos(horaMinutos) {
      return (
        parseInt(horaMinutos.split(":")[0]) * 60 +
        parseInt(horaMinutos.split(":")[1])
      );
    },
    calcularFechaActual() {
      var mes;
      var fecha_hoy = new Date();

      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        // this.fechaIngreso = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        // this.fechaIngreso = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }
    },
    emailsProgramacion: function () {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      const BASE_URL = `${this.ip}api/emailsProgramacion`;
      axios
        .get(BASE_URL, config)
        .then(res => {
          let data = res.data.data;
          this.SedesProgramacion = data;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    this.calcularFechaActual();
    this.emailsProgramacion();
    this.rol = localStorage.getItem('rol');
    if (localStorage.getItem('rol') != 1) {
      this.sede = localStorage.getItem('sede');
    }
    document.title = "Avanti | Reporte programación";
  },
};
</script>
<style scoped>
.card {
  box-shadow: 0 0 0 0;
  border-radius: 15px;
  padding: 2%;
}

.title-card {
  color: grey;
  margin-top: 1% !important;
  margin-bottom: 0% !important;
}

.btn {
  border-radius: 5px;
}

.titulo-mensaje {
  font-size: 15px;
  color: grey;
}

.el-table {
  border-radius: 10px;
}

.card-header {
  padding-bottom: 10px !important;
  background-color: #f3f2ee;
  border-radius: 15px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Reportes/Programacion.vue